const pt = {
  meta: { code: "pt", label: "Português" },
  nav: {
    brand: "IQ Log",
    diagnostics: "Avaliações",
    mypage: "Minha Página",
    login: "Entrar",
    register: "Cadastrar",
    logout: "Sair",
  },
  hero: {
    eyebrow: "Plataforma de avaliação",
    title: "Descubra sua essência através das avaliações",
    subtitle1: "Pensamento, personalidade e aptidão — totalmente visualizados",
    subtitle2: "Veja seus pontos fortes e fracos em 5 minutos",
    subtitle3: "Cada avaliação se torna seu dado",
    cta_primary: "Iniciar avaliação",
    cta_secondary: "Ver catálogo",
    disclaimer: "Informação de referência / Não médica",
  },
  categories: {
    ability: "Habilidade",
    personality: "Personalidade",
    mental: "Mental",
    aptitude: "Aptidão",
    traits: "Características",
  },
  catalog: {
    title: "Todas as avaliações",
    subtitle: "17 testes / 5 categorias",
    filter_all: "Todas",
    duration: "min",
    difficulty: { easy: "Fácil", medium: "Médio", hard: "Difícil" },
    question_count: "Qs",
    start: "Iniciar",
  },
  quiz: {
    question: "Pergunta",
    of: "/",
    next: "Próximo",
    prev: "Voltar",
    submit: "Ver resultado",
    progress: "Progresso",
    exit: "Sair",
    required: "Selecione uma opção",
    submitting: "Pontuando…",
  },
  result: {
    overall: "Pontuação geral",
    type_label: "Tipo",
    share_link: "Compartilhe o resultado por link",
    back_to_catalog: "Fazer outra avaliação",
    view_mypage: "Ver histórico em Minha Página",
    premium_title: "Desbloqueie a análise detalhada",
    premium_subtitle: "Com o premium, você verá tudo abaixo:",
    feature_breakdown: "Detalhamento de pontuação",
    feature_cause: "Análise de causa raiz",
    feature_plan: "Plano de melhoria",
    feature_pdf: "Relatório PDF (A4)",
    price: "¥980",
    price_note: "(Pagamento seguro via Stripe)",
    price_free: "Grátis",
    price_free_note: "(Tempo limitado · 100% grátis)",
    unlock_button: "Pagar com Stripe",
    unlock_button_free: "Desbloquear grátis",
    unlock_requires_auth: "Faça login para desbloquear",
    unlock_save_first: "Salve seu resultado com uma conta primeiro",
    unlocking: "Redirecionando ao Stripe…",
    free_only_notice: "A versão gratuita mostra apenas pontuação geral e tipo.",
    compliance_note:
      "Esta avaliação é apenas informação de referência e não um diagnóstico médico. Evitamos linguagem definitiva ou alarmista.",
  },
  premium: {
    title: "Relatório de análise detalhada",
    summary: "Resumo geral",
    strengths: "Pontos fortes",
    weaknesses: "Áreas de crescimento",
    improvements: "Plano de melhoria",
    dimensions: "Pontuações por dimensão",
    download_pdf: "Baixar PDF",
    pdf_soon: "Exportar PDF (em breve)",
  },
  mypage: {
    title: "Minha Página",
    subtitle: "Seu histórico, tendências de pontuação e selos",
    total: "Total de avaliações",
    average: "Pontuação média",
    premium_count: "Desbloqueado",
    categories_covered: "Categorias cobertas",
    trend_title: "Tendência de pontuação",
    history_title: "Histórico",
    badges_title: "Selos",
    unlock_3_title: "Desbloquear Análise Composta",
    unlock_3_desc: "Faça mais {n} avaliação(ões) para desbloquear a análise composta",
    unlocked: "Análise composta desbloqueada",
    no_history: "Nenhuma avaliação ainda — comece a primeira agora.",
  },
  auth: {
    login_title: "Entrar",
    register_title: "Criar conta",
    email: "E-mail",
    password: "Senha (mín. 6 caracteres)",
    name: "Nome de exibição (opcional)",
    login_btn: "Entrar",
    register_btn: "Cadastrar",
    go_register: "Não tem conta? Cadastre-se",
    go_login: "Já tem conta? Entrar",
    anon_note: "Avaliações são gratuitas e anônimas. Conta apenas para salvar resultados e desbloquear premium.",
    success_register: "Conta criada",
    success_login: "Logado",
    consent_section: "Consentimento",
    consent_required: "Aceite os itens obrigatórios",
    accept_terms_pre: "Eu concordo com os",
    terms_link: "Termos de Serviço",
    accept_terms_post: "",
    accept_privacy_pre: "Li a",
    privacy_link: "Política de Privacidade",
    accept_privacy_post: "e consinto com o tratamento dos meus dados pessoais",
    accept_age: "Tenho 16 anos ou mais (ou tenho consentimento de meu responsável legal)",
    accept_marketing: "Enviem-me e-mails sobre novas avaliações e promoções",
    optional: "opcional",
  },
  landing: {
    status_online: "SISTEMA ONLINE",
    status_subtitle: "DIAGNOSTIC OS v2.0",
    status_tests: "17 TESTES",
    status_langs: "14 IDIOMAS",
    status_ai: "AI · ON",
    title_line1: "Descubra sua essência",
    title_line2: "em 5 minutos.",
    trust_diagnostics: "AVALIAÇÕES",
    trust_languages: "IDIOMAS",
    trust_per_test: "POR TESTE",
    hud_readout: "LEITURA PRINCIPAL",
    hud_score_unit: "/100 GERAL",
    hud_band: "FAIXA · GOLD",
    hud_dimensions: "DIMENSÕES",
    hud_dimensions_status: "3 / 3 ATIVO",
    hud_syslog: "LOG DE SISTEMA",
    cat_eyebrow: "// CATEGORIAS",
    cat_title_pre: "5 categorias · ",
    cat_title_highlight: "17 avaliações",
    view_all: "Ver tudo",
    proto_eyebrow: "// PROTOCOLO",
    proto_title_pre: "Desbloqueie sua essência ",
    proto_title_highlight: "em 3 passos.",
    step1_title: "Escolha um teste",
    step1_body: "Escolha entre 17 testes. Início anônimo.",
    step2_title: "Responda em 5 min",
    step2_body: "Barra de progresso e selos te impulsionam.",
    step3_title: "Desbloqueie com IA",
    step3_body: "Pontuação detalhada, plano e PDF.",
    final_eyebrow: "// PRONTO?",
    final_title_pre: "Sua essência ",
    final_title_highlight: "em 5 min.",
    final_subtitle: "Veja seus pontos fortes e fracos em 5 minutos",
    final_button: "Começar avaliação",
  },
  footer: {
    tagline: "Plataforma de avaliação para seu pensamento, personalidade e aptidão",
    rights: "Todos os direitos reservados.",
    legal: "Legal",
    privacy: "Privacidade",
    terms: "Termos",
    about_label: "Sobre / Empresa",
    compliance_label: "Conformidade Internacional",
    tokushoho_label: "Lei Comercial do Japão",
    data_protection_label: "Proteção de Dados (Internacional)",
    data_request_label: "Excluir Dados / Opt-out",
    disclaimer_label: "Aviso Legal",
    disclaimer_full:
      "Este serviço é apenas para referência e não um diagnóstico médico. Não usamos linguagem definitiva ou alarmista.",
  },
  badges: {
    "first-diagnosis": "Primeira avaliação",
    "three-diagnostics": "3 avaliações",
    "five-diagnostics": "5 avaliações",
    "ten-diagnostics": "10 avaliações",
    "high-performer": "Alto desempenho",
    "premium-user": "Usuário premium",
  },
  lang_selector: "Idioma",
  payment: {
    processing_title: "Verificando pagamento…",
    processing_subtitle: "Retornado do Stripe — gerando análise detalhada (até 20s)",
    success: "Pagamento confirmado — premium desbloqueado",
    expired: "Sessão de checkout expirada. Tente novamente.",
    error: "Não foi possível verificar o pagamento. Contate o suporte.",
  },
};
export default pt;
